<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pb-0">
        <div class="tw-flex tw-items-center" v-if="isLoading">
          <base-skeleton-loader class="tw-h-16 tw-w-16 md:tw-h-24 md:tw-w-24 tw-flex-shrink-0 tw-rounded-full" />
          <base-skeleton-loader class="tw-ml-4 tw-h-4 tw-w-64" />
        </div>
        <div class="tw-flex tw-items-center" v-else>
          <div class="tw-h-16 tw-w-16 md:tw-h-24 md:tw-w-24 tw-flex-shrink-0">
            <Avatar :business-id="business.businessId" editable avatar-type="business" />
          </div>
          <h1 class="tw-text-xl sm:tw-text-2xl md:tw-text-3xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin tw-ml-4">{{ business.name }}</h1>
        </div>
        <base-tabs class="tw-mt-2 tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)">
          <base-tab :selected="$route.meta.component === 'AdminBusinessSettingsView'" title="Settings" />
          <base-tab :selected="$route.meta.component === 'AdminBusinessSubscription'" title="Subscriptions" />
          <base-tab :selected="$route.meta.component === 'BusinessPaymentHistory'" title="Payments" />
          <base-tab :selected="$route.meta.component === 'BusinessStripeConnection'" title="Stripe Connection" />
        </base-tabs>
      </base-content>
    </div>
    <base-content>
      <keep-alive>
        <component
          :is="currentComponent"
          :business-id="businessId"
          :business-name="business.name"
          :stripe-customer-id="business.stripeCustomerId"
          :business="business"
          @reload="loadBusiness"
        />
      </keep-alive>
    </base-content>
  </div>
</template>

<script>
export default {
  components: {
    Avatar: () => import("@/components/Avatar"),
    AdminBusinessSubscription: () => import("@/views/admin/business/components/AdminBusinessSubscription"),
    AdminBusinessSettings: () => import("@/views/admin/business/components/AdminBusinessSettings"),
    BusinessPaymentHistory: () => import("@/views/admin/business/components/BusinessPaymentHistory"),
    BusinessStripeConnection: () => import("@/views/admin/business/components/BusinessStripeConnection"),
  },
  props: {
    businessId: String,
    stripeCustomerId: String,
  },
  data() {
    return {
      isLoading: false,
      business: {},
      tabs: [
        { title: "Settings", component: "AdminBusinessSettings", route: "settings" },
        { title: "Subscriptions", component: "AdminBusinessSubscription", route: "subscription" },
        { title: "Payments", component: "BusinessPaymentHistory", route: "payments" },
        { title: "Stripe Connection", component: "BusinessStripeConnection", route: "connection" },
      ],
    };
  },
  computed: {
    currentComponent() {
      return this.$route.meta.component;
    },
  },
  mounted() {
    this.loadBusiness();
  },
  methods: {
    async loadBusiness() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/admin/businesses/${this.businessId}`);
        this.business = response.data;
      } finally {
        this.isLoading = false;
      }
    },
    href(path) {
      if (this.$route.path !== path) {
        this.$router.push({
          path,
          params: { businessId: this.businessId },
        });
      }
    },
    tabClick(tabTitle) {
      const tab = this.tabs.find((t) => t.title === tabTitle);
      this.href(`/admin/businesses/${this.businessId}/business/${tab.route}`);
    },
  },
};
</script>
